import i18next, { i18n as i18nInstance } from 'i18next'
import { initReactI18next, DefaultResources } from 'react-i18next'
import detector from 'i18next-browser-languagedetector'

import { languages, translationResources } from './resources'

const createI18n = (lang: string): i18nInstance => {
  const i18n = i18next.createInstance().use(initReactI18next)
  i18n.use(detector).init({
    detection: {
      order: ['querystring', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      caches: []
    },
    interpolation: {
      defaultVariables: {
        companyName: 'Goodstack'
      }
    },
    resources: translationResources,
    fallbackLng: {
      default: [lang]
    },
    react: {
      useSuspense: false
    }
  })

  return i18n
}

export const i18n = createI18n(languages.en)

export type LocaleKey = keyof DefaultResources['eduHostedValidationForm']
